import { DeleteApplicationReq, DeleteApplicationRes, GetAllApplicationsReq, GetAllApplicationsRes, NewApplicationReq, NewApplicationRes } from '../interfaces/application.interface';
import { GetAllEventRisksReq, GetAllEventRisksRes, UpdateEventRiskReq, UpdateEventRiskRes } from '../interfaces/eventRisk.interface';
import {API} from './api'



export const getAllApplicationsService = async (data: GetAllApplicationsReq): Promise<GetAllApplicationsRes>=>{
    try {
        const res = await API.get('/v1/application');
        return res.data;
    } catch (error) {
        throw error
    }
}

export const deleteApplicationsService = async (data: DeleteApplicationReq): Promise<DeleteApplicationRes>=>{
    try {
        const res = await API.delete(`/v1/application/${data.id}`);
        return res.data;
    } catch (error) {
        throw error
    }
}


export const newApplicationService = async (data: NewApplicationReq): Promise<NewApplicationRes>=>{
    try {
        const res = await API.post('/v1/application', data);
        return res.data;
    } catch (error) {
        throw error
    }
}

